var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserFocused = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5692 6.3636C13.2328 6.3636 12.1494 7.50323 12.1494 8.90905C12.1494 10.3149 13.2328 11.4545 14.5692 11.4545C15.9056 11.4545 16.9889 10.3149 16.9889 8.90905C16.9889 7.50323 15.9056 6.3636 14.5692 6.3636ZM10.5363 8.90905C10.5363 6.56602 12.3419 4.66663 14.5692 4.66663C16.7965 4.66663 18.6021 6.56602 18.6021 8.90905C18.6021 11.2521 16.7965 13.1515 14.5692 13.1515C12.3419 13.1515 10.5363 11.2521 10.5363 8.90905Z",
  fill: "#76B7F7"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.30994 18.2424C7.30994 15.8994 9.11554 14 11.3429 14H17.7955C20.0229 14 21.8285 15.8994 21.8285 18.2424V21.6363C21.8285 22.5735 21.1062 23.3333 20.2153 23.3333H8.92311C8.03218 23.3333 7.30994 22.5735 7.30994 21.6363V18.2424ZM11.3429 15.6969C10.0065 15.6969 8.92311 16.8366 8.92311 18.2424V21.6363H20.2153V18.2424C20.2153 16.8366 19.1319 15.6969 17.7955 15.6969H11.3429Z",
  fill: "#76B7F7"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserFocused);
export default ForwardRef;